import { useCallback } from 'react';

export const useFeaturePath = (featureRouteName: string) => {
    return useCallback(
        (route = '') => {
            return `${featureRouteName}${route}`;
        },
        [featureRouteName]
    );
};
